import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";
import { SvgIcon } from "../SvgIcon";

export function ImmutableSymbolInverse({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("ImmutableSymbol");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 33 32"
      sx={mergeSx({ w: "32px", fill: "base.color.brand.2" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

ImmutableSymbolInverse.displayName = "ImmutableSymbolInverse";
